import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  success: {
    charactersSaved: "Charaktere Gespeichert",
    charactersAddedToLibrary: "Charaktere zur Bibliothek Hinzugefügt"
  },
  storySetup: {
    titles: {
      new: "Neue Geschichte Erstellen",
      edit: "Geschichte Bearbeiten",
      continue: "Geschichte Fortsetzen"
    },
    basicInfo: {
      storyTitle: "Geschichtentitel",
      titlePlaceholder: "Geben Sie den Titel der Geschichte ein",
      silverLining: "Kern der Geschichte",
      descriptionPlaceholder: "Worum geht es in Ihrer Geschichte wirklich? Dies wird helfen, die Erzählung zu leiten.",
      genre: "Genre",
      selectGenre: "Genre auswählen",
      environment: "Umgebung",
      selectEnvironment: "Umgebung auswählen",
      theme: "Themen",
      storyLength: "Geschichtenlänge",
      storyLengthWithNumberOfPages: "Geschichtenlänge (Anzahl der Seiten)",
      selectLength: "Länge auswählen",
      aiSuggest: "KI-Vorschlag",
      missingValues: "Fehlende Werte",
      fillRequired: "Bitte füllen Sie alle erforderlichen Felder aus",
      titleGenerated: "Titel Generiert",
      generationError: "Generierungsfehler",
      tryAgain: "Bitte versuchen Sie es erneut",
      addCustomGenre: "Benutzerdefiniertes Genre hinzufügen...",
      addCustomEnvironment: "Benutzerdefinierte Umgebung hinzufügen...",
      addCustomTheme: "Benutzerdefiniertes Thema hinzufügen...",
      autoGenerate: "Automatisch Generieren",
      formDataGenerated: "Formulardaten generiert",
      dataUpdated: "Daten aktualisiert",
      formDataEnhanced: "Formulardaten verbessert",
      noEnhancementsNeeded: "Keine Verbesserungen erforderlich",
      formDataUpToDate: "Formulardaten sind aktuell",
      needSomeInfo: "Wir benötigen einige Informationen, um Ihre Geschichte zu erstellen"
    },
    genres: {
      fantasy: "Fantasy",
      scienceFiction: "Science-Fiction",
      mystery: "Krimi",
      romance: "Romantik",
      adventure: "Abenteuer",
      horror: "Horror",
      historicalFiction: "Historische Fiktion",
      contemporary: "Gegenwart",
      superhero: "Superheld",
      kidsStory: "Kindergeschichte",
      thriller: "Thriller"
    },
    environments: {
      urbanCity: "Großstadt",
      medievalCastle: "Mittelalterliche Burg",
      spaceStation: "Raumstation",
      forest: "Wald",
      desert: "Wüste",
      ocean: "Ozean",
      mountain: "Berg",
      smallTown: "Kleinstadt",
      futuristicMetropolis: "Futuristische Metropole",
      underwaterKingdom: "Unterwasserkönigreich",
      hauntedMansion: "Spukhaus",
      mountainCavern: "Berghöhle",
      dragonLair: "Drachenhöhle",
      researchLaboratory: "Forschungslabor",
      futureCommunications: "Zukunftskommunikation",
      magicalLibrary: "Magische Bibliothek",
      rainyNight: "Regennacht",
      ancientTemple: "Antiker Tempel"
    },
    storyLengths: {
      short: "Kurz",
      medium: "Mittel",
      long: "Lang",
      natural: "Natürlich"
    },
    characters: {
      name: "Charaktername",
      description: "Charakterbeschreibung",
      title: "Charaktere",
      browseCharacters: "Charaktere durchsuchen",
      makePublic: "öffentlich machen"
    },
    character: {
      name: "Charaktername",
      namePlaceholder: "Charakternamen eingeben",
      role: "Charakterrolle",
      selectRole: "Charakterrolle auswählen",
      description: "Charakterbeschreibung",
      descriptionPlaceholder: "Charakterbeschreibung eingeben",
      create: "Charakter erstellen",
      update: "Charakter aktualisieren",
      roles: {
        protagonist: "Protagonist",
        antagonist: "Antagonist",
        deuteragonist: "Deuteragonist",
        mentor: "Mentor",
        comic_relief: "Comic Relief",
        mysterious: "Mysteriöse Figur",
        love_interest: "Liebesinteresse",
        anti_hero: "Antiheld",
        sidekick: "Begleiter",
        shapeshifter: "Gestaltwandler",
        guardian: "Wächter",
        catalyst: "Katalysator"
      }
    },
    themeSection: {
      title: "Themen"
    },
    themeOptions: {
      friendship: "Freundschaft",
      love: "Liebe",
      betrayal: "Verrat",
      redemption: "Erlösung",
      growth: "Wachstum",
      power: "Macht",
      justice: "Gerechtigkeit",
      family: "Familie",
      courageBravery: "Mut & Tapferkeit",
      magicMythology: "Magie & Mythologie",
      survival: "Überleben",
      warConflict: "Krieg & Konflikt",
      freedomRebellion: "Freiheit & Rebellion",
      violenceRevenge: "Gewalt & Rache",
      passionEroticism: "Leidenschaft & Erotik",
      quest: "Quest",
      ancientWisdom: "Alte Weisheit",
      timeTravel: "Zeitreise",
      technology: "Technologie",
      identity: "Identität",
      sacrifice: "Opfer",
      transformation: "Transformation",
      discovery: "Entdeckung",
      knowledge: "Wissen",
      paradox: "Paradox",
      magic: "Magie"
    },
    buttons: {
      create: "Geschichte Erstellen",
      update: "Geschichte Aktualisieren"
    },
    success: {
      title: "Geschichte Einrichtung Abgeschlossen",
      description: "Ihre Geschichte wurde erfolgreich erstellt und ist bereit für Ihre kreative Reise."
    },
    failure: {
      title: "Geschichte Einrichtung Fehlgeschlagen",
      description: "Die Geschichte konnte nicht eingerichtet werden. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut."
    },
  },
  story: {
    parts: "Teile",
    part: "Teil",
    continueStory: "Geschichte Fortsetzen",
    print: "Drucken",
    generatingSummary: "Zusammenfassung Wird Generiert",
    generatingContinuation: "Fortsetzung Wird Generiert",
    pleaseWait: "Bitte warten...",
    backToDashboard: "Zurück zum Dashboard",
    extractCharacters: "Charaktere Extrahieren",
    foundCharacters: "Gefundene Charaktere",
    addSelectedCharacters: "Ausgewählte Charaktere Hinzufügen",
    share: "Teilen",
    viewEntire: "Gesamte Geschichte Anzeigen",
    viewPaginated: "Paginiert Anzeigen",
    tooltips: {
      upgradeToContinue: "Upgraden Sie, um Geschichten fortzusetzen",
      upgradeToShare: "Upgraden Sie, um Geschichten zu teilen",
      upgradeToExtract: "Upgraden Sie, um Charaktere zu extrahieren"
    },
    ratings: {
      submitted: "Bewertung abgeschickt",
      thankYou: "Vielen Dank für die Bewertung dieser Geschichte!",
      error: "Fehler",
      failedToSubmit: "Bewertung konnte nicht übermittelt werden"
    },
    sharing: {
      dialogTitle: "Teilen Sie Ihre Geschichte",
      dialogDescription: "Wählen Sie aus, wo Sie Ihre Geschichte teilen möchten",
      privacy: "Geschichte-Privatsphäre",
      privacyLevels: {
        private: "Privat",
        public: "Öffentlich",
        friends: "Nur Freunde"
      },
      platform: "Plattform",
      selectPlatform: "Plattform auswählen",
      customMessage: "Benutzerdefinierte Nachricht",
      customMessagePlaceholder: "Fügen Sie Ihrem Beitrag eine Nachricht hinzu...",
      shareButton: "Geschichte Teilen",
      successTitle: "Geschichte erfolgreich geteilt",
      successMessage: "Ihre Geschichte wurde auf {{platform}} geteilt",
      authRequired: "Authentifizierung erforderlich",
      authMessage: "Bitte melden Sie sich an, um Geschichten zu teilen."
    },
    upgrade: {
      title: "Upgrade Erforderlich",
      continueDescription: "Upgraden Sie Ihr Konto, um Geschichtssequenzen zu erstellen.",
      continueFeature: "Erstellen Sie Geschichtssequenzen mit einem Premium-Abonnement",
      shareDescription: "Upgraden Sie Ihr Konto, um Geschichten zu teilen.",
      shareFeature: "Teilen Sie Geschichten mit einem Basic-Abonnement",
      extractDescription: "Upgraden Sie Ihr Konto, um Charaktere zu extrahieren.",
      extractFeature: "Extrahieren Sie Charaktere mit einem Premium-Abonnement",
      upgradeButton: "Jetzt Upgraden"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "Vorherige Seite",
      continue: "Fortfahren",
      returnToDashboard: "Zurück zum Dashboard",
      page: "Seite",
      of: "von",
      remainingPages: "Verbleibende Seiten",
    },
    input: {
      customResponse: "Benutzerdefinierte Antwort"
    },
    choices: {
      yourChoice: "Ihre Auswahl"
    },
    completedStory: {
      title: "Geschichte Abgeschlossen",
      description: "Ihre Geschichte hat ihr Ende erreicht!",
    },
  },
  imageGeneration:{
    ready: "Bereit",
    imageReady: "Bild Bereit",
    insufficientCredits: "Unzureichende Credits",
    needMoreCredits: "Mehr Credits Benötigt",
    failed: "Fehlgeschlagen",
    processing: "Verarbeitung",
    pleaseWait: "Bitte warten",
    unexpectedError: "Unerwarteter Fehler",
    generateImage: "Bild Generieren",
    costsCredits: "Kosten Credits",
    generatingImage: "Bild Wird Generiert",
    credits: "Credits",
    creditsLabel: "Credits",
    selectImage: "Bild Auswählen",
    selectImageDescription: "Wählen Sie ein Bild aus, um das Ereignis darzustellen",
    selectPreferred: "Bevorzugtes Bild Auswählen",
    contentNotFound: "Inhalt Nicht Gefunden",
    saved: "Bild Gespeichert",
    imageSaved: "Bild Gespeichert",    
    partialSuccess: "Teilweise Erfolgreich",
    someImagesFailed: "Einige Bilder sind fehlgeschlagen",
  },
  audioGeneration: {
    insufficientCredits: "Unzureichende Credits",
    generateAudio: "Audio Generieren",
    generatingAudio: "Audio Wird Generiert",
    pleaseWait: "Bitte warten",
    failed: "Fehlgeschlagen",
    success: "Erfolg",
    audioReady: "Audio Bereit",
    audioAvailable: "Audio Verfügbar"
  },
  storyRewrite:{
    rewritesLeft: "Verbleibende Umschreibungen",
    rewriteStory: "Geschichte Umschreiben",
    rewriteComplete: "Geschichte Umschreiben Abgeschlossen",
    refreshingContent: "Inhalt Wird Aktualisiert",
    refreshError: "Aktualisierungsfehler",
    refreshErrorMessage: "Ein unerwarteter Fehler ist aufgetreten, während die Geschichte aktualisiert wurde. Bitte versuchen Sie es erneut.",
    noRewritesLeft: "Keine Umschreibungen Verbleibend",
    tryPageRefresh: "Versuchen Sie, die Seite zu aktualisieren",
  },
  loadingMessages: {
    craftingTheNextChapter: "Das Nächste Kapitel Gestalten",
    weavingThePlotTwists: "Die Wendungen Der Handlung Weben",
    yourAdventureIsAboutToUnfold: "Deine Abenteuer Stehen Kurz Vor Der Entfaltung",
    developingTheCharacters: "Die Charaktere Entwickeln",
    imaginingNewPossibilities: "Neue Möglichkeiten Vorstellen",
  },
};
